import { useEffect, useState } from 'react'
import {
  Alert,
  Box,
  FormControl,
  RadioGroup,
  Typography,
  useTheme,
  Stack
} from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import CancelIcon from '@mui/icons-material/Cancel'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'

// Wrapper is for showing the correct answer after the user has submitted their answer
export const QuestionOptionWrapper = ({ ...props }) => {
  const [showAnswer, setShowAnswer] = useState(false)
  useEffect(() => {
    setShowAnswer(props.initialValue !== undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.question])

  return (
    <QuestionOptionsTemplate
      handleOnValueChange={() => setShowAnswer(true)}
      showSummary={showAnswer}
      {...props}
    />
  )
}

const QuestionOptionsTemplate = ({
  question,
  options,
  correctAnswer,
  correctMessage,
  wrongMessage,
  handleOnValueChange,
  initialValue = null,
  showSummary = false,
  submitError = false,
  ...otherProps
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [currentValue, setCurrentValue] = useState(null)

  useEffect(() => {
    setCurrentValue(initialValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question])

  const onChange = event => {
    setCurrentValue(event.target.value)
    if (handleOnValueChange !== undefined) {
      handleOnValueChange(event)
    }
  }
  const alertSx = {
    padding: 8,
    alignItems: 'center',
    '& .MuiAlert-icon': {
      padding: 0
    },
    '& .MuiAlert-message': {
      fontSize: 16,
      padding: 0
    }
  }

  const backgroundColor = showSummary
    ? currentValue === correctAnswer
      ? colors.Green100
      : colors.Peach50
    : theme.palette.background.default

  const radioColor = showSummary
    ? currentValue === correctAnswer
      ? colors.Green400
      : colors.Watermelon400
    : undefined
  return (
    <Stack
      spacing={8}
      sx={{ padding: 0, paddingBottom: 8, width: '100%' }}
      {...otherProps}>
      <Typography alignSelf='flex-start' color={colors.MidnightTeal400}>
        {question}
      </Typography>
      <FormControl
        name={'question-option-form'}
        // fullWidth
        sx={{
          backgroundColor: 'none'
        }}>
        <Box
          borderRadius={5}
          padding={8}
          sx={{
            backgroundColor: backgroundColor,
            border:
              submitError && !currentValue
                ? '1px solid ' + theme.palette.error.light
                : 'none'
          }}>
          <RadioGroup
            name='question-options'
            sx={{
              display: 'flex',
              gap: 6,
              '& .MuiRadio-root.Mui-checked': { color: radioColor }
            }}
            value={currentValue}
            onChange={e => onChange(e)}>
            {options}
          </RadioGroup>
        </Box>
      </FormControl>
      {showSummary && correctMessage ? (
        <Box width='100%'>
          {currentValue === null ? null : currentValue === correctAnswer ? (
            <Alert
              severity='success'
              sx={{
                backgroundColor: colors.SecondaryLightGreen,
                color: colors.SuccessGreen,
                ...alertSx
              }}
              icon={<CheckCircleRoundedIcon sx={{ fontSize: 24 }} />}>
              {correctMessage}
            </Alert>
          ) : (
            <Alert
              severity='error'
              sx={{
                backgroundColor: colors.SecondaryLightRed,
                color: colors.ErrorRed,
                ...alertSx
              }}
              icon={<CancelIcon sx={{ fontSize: 24 }} />}>
              {wrongMessage || t('stepQuiz.pleaseTryAgain')}
            </Alert>
          )}
        </Box>
      ) : null}
    </Stack>
  )
}

export default QuestionOptionsTemplate
